import { useMemo } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeedSection from './components/FeedSection';
import EvidenceSection from './components/EvidenceSection';
import SearchSection from './components/SearchSection';
import RankingSection from './components/RankingSection';
import SceneSection from './components/SceneSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';
import BackTop from './components/BackTop';
import { faqs } from '@/mocks/gossip';

const baseUrl = 'https://urqzcj.cn';

export default function Home() {
  const jsonLd = useMemo(() => {
    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    };
    const webSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '吃瓜最新 - 新实锤新证据挖掘站',
      url: baseUrl,
      description:
        '吃瓜最新，新实锤与新证据挖掘站，新截图、新录音、新视频持续更新，从蛛丝马迹中还原事件真相。',
      inLanguage: 'zh-CN',
    };
    return [webSchema, faqSchema];
  }, []);

  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-950">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <FeedSection />
        <EvidenceSection />
        <SearchSection />
        <RankingSection />
        <SceneSection />
        <FaqSection />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}